export const GUIDED_OVERLAY_MASK_CLASS =
  'bg-slate-950/88 backdrop-blur-[6px] backdrop-saturate-[0.82]';

export const GUIDED_OVERLAY_SLICE_CLASS =
  'transition-all duration-500 ease-out';

export const GUIDED_OVERLAY_FRAME_CLASS =
  'pointer-events-none absolute rounded-2xl border border-violet-200/70 shadow-[0_0_0_1px_rgba(255,255,255,0.3),0_0_0_9999px_rgba(2,6,23,0.28),0_0_52px_rgba(139,92,246,0.42)] transition-all duration-500 ease-out';

export const GUIDED_OVERLAY_PANEL_BASE_CLASS =
  'rounded-3xl border border-white/10 bg-[color:var(--color-surface-elevated)] text-[color:var(--color-slate-100)] shadow-[0_24px_65px_rgba(2,6,23,0.72)] backdrop-blur-xl';
